import successIcon from "@assets/icons/success.svg";
import trashcanIcon from "@assets/icons/trashcan.svg";
import { Tooltip } from "antd";

export default function FileUploadSuccess({ onDelete, filename }) {
  return (
    <div className="flex items-center justify-between p-2 border rounded-lg border-border">
      <div className="flex items-center gap-2.5">
        <img src={successIcon} alt="success" />
        <div className="flex flex-col gap-1 max-w-[150px] !truncate">
          <Tooltip title={filename}>
            <label className="text-xs font-medium !truncate text-text-main">
              {filename}
            </label>
          </Tooltip>
          <label className="text-[11px] font-medium text-primary-tint">
            Upload complete
          </label>
        </div>
      </div>

      <img
        src={trashcanIcon}
        onClick={onDelete}
        alt="delete"
        className="cursor-pointer hover:scale-105"
      />
    </div>
  );
}
